import { Handler } from './types';

export function createPubSub<T>() {
  const topics = new Map<keyof T, Set<Handler<T>>>();

  function subscribe<Key extends string & keyof T>(topic: Key, handler: Handler<T>): () => void {
    const subscribers = topics.get(topic);

    const unsubscribeHandler = () => unsubscribe(topic, handler);

    if (!subscribers) {
      topics.set(topic, new Set([handler]));

      return unsubscribeHandler;
    }

    subscribers.add(handler);

    return unsubscribeHandler;
  }

  function publish<Key extends string & keyof T>(topic: Key, message: T[Key]) {
    const handlers = topics.get(topic);

    if (!handlers) {
      return;
    }

    for (const handle of handlers.values()) {
      handle(message);
    }
  }

  function unsubscribe<Key extends string & keyof T>(topic: Key, handler: Handler<T>) {
    topics.get(topic)?.delete(handler);
  }

  return {
    publish,
    subscribe,
    unsubscribe,
  };
}
